import "core-js/modules/es.array.push.js";
import { InventoryService } from '@/services/inventory.service';
export default {
  data() {
    return {
      headers: [{
        label: 'Product Name',
        key: 'productname'
      }],
      items: []
    };
  },
  async mounted() {
    const {
      data
    } = await InventoryService.getInventory();
    const itemsByProduct = [];
    const objectKeys = Object.keys(data);
    // Loop by state
    for (const state of objectKeys) {
      // Loop through items in state
      const itemKeys = Object.keys(data[state]);
      for (const product of itemKeys) {
        // Check if item is already on the table
        const exists = itemsByProduct.find(o => o.productname == product);
        // Add item to the table
        if (!exists) {
          const item = {
            productname: product
          };
          // Assign the state levels to the new item
          item[`${state} Levels`] = data[state][product];
          itemsByProduct.push(item);
          // Add state to header
          this.headers.push(`${state} Levels`);
        } else {
          // Add state levels to item
          const index = itemsByProduct.findIndex(o => o.productname == product);
          itemsByProduct[index][`${state} Levels`] = data[state][product];
          // Add state to header
          this.headers.push(`${state} Levels`);
        }
      }
    }
    this.items = itemsByProduct;
  }
};